import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    isbulkImportOpen: false,
    isRemoveFileDialogOpen: false,
    isTemplateDownloadSuccess: false,
    isTemplateDownloadFailed: false,
    isFetchUsersFailed: false,
    isFetchFilesFailed: false,
    isUploadDialogOpen: false,
    isFileUploadDisabled: false,
    isUserUpdateFailed: false,
    isFileUploadFailed: false,
    currentFileName: '',
    currentUploadId: null,
    isRemoveFileFailed: false,
    isRemoveFileSuccess: false,
    isUploadingFiles: false,
    isRemoveFileLoading: false,
    users: { data: [], totalItems: 0 },
    overallTotalItems: 0,
    isImportSuccess: false,
    importSuccessMessage: '',
    isImportError: false,
    importErrorMessage: '',
    isRemoveUserDialogOpen: false,
    isRemoveUserFailed: false,
    isRemoveUserSuccess: false,
    isRemoveUserLoading: false,
    selectedUserIdToDelete: null,
};

export const bulkImportUsersSliceId = 'bulkImportUsers';

const bulkImportUsersSlice = createSlice({
    name: bulkImportUsersSliceId,
    initialState,
    reducers: {
        setIsBulkImportOpen: state => {
            state.isbulkImportOpen = !state.isbulkImportOpen;
        },
        setIsUploading: (state, action) => {
            state.isUploadingFiles = action.payload;
        },
        setRemoveCurrentFileDialogOpen: state => {
            state.isRemoveFileDialogOpen = !state.isRemoveFileDialogOpen;
        },
        setRemoveFileFailedAlert: state => {
            state.isRemoveFileFailed = !state.isRemoveFileFailed;
        },
        setRemoveFileSuccessAlert: state => {
            state.isRemoveFileSuccess = !state.isRemoveFileSuccess;
        },
        setIsTemplateDownloadSuccess: state => {
            state.isTemplateDownloadSuccess = !state.isTemplateDownloadSuccess;
        },
        setIsTemplateDownloadFailed: state => {
            state.isTemplateDownloadFailed = !state.isTemplateDownloadFailed;
        },
        setIsFetchFilesFailed: state => {
            state.isTemplateDownloadFailed = !state.isTemplateDownloadFailed;
        },
        setIsFetchUsersFailed: state => {
            state.isFetchUsersFailed = !state.isFetchUsersFailed;
        },
        setIsUpdateUserFailed: state => {
            state.isUserUpdateFailed = !state.isUserUpdateFailed;
        },
        setUploadDialogOpen: state => {
            state.isUploadDialogOpen = !state.isUploadDialogOpen;
        },
        setShouldFileUpload: (state, action) => {
            state.isFileUploadDisabled = action.payload;
        },
        setUsers: (state, action) => {
            state.users = action.payload;
        },
        setOverallTotalItems: (state, action) => {
            state.overallTotalItems = action.payload;
        },
        setIsImportSuccess: (state, action) => {
            state.isImportSuccess = !state.isImportSuccess;
            state.importSuccessMessage = action.payload || '';
        },
        setIsImportError: (state, action) => {
            state.isImportError = true;
            state.importErrorMessage = action.payload || '';
        },
        setIsUploadFileFailed: state => {
            state.isFileUploadFailed = !state.isFileUploadFailed;
        },
        clearImportError: state => {
            state.isImportError = false;
            state.importErrorMessage = '';
        },
        setCurrentFileName: (state, action) => {
            state.currentFileName = action.payload;
        },
        setCurrentFileId: (state, action) => {
            state.currentUploadId = action.payload;
        },
        deleteFileReducer: state => {
            state.users = { data: [], totalItems: 0 };
            state.currentUploadId = null;
            state.currentFileName = '';
        },
        resetState: state => {
            state = initialState;
        },
        setIsRemoveFileLoading: (state, action) => {
            state.isRemoveFileLoading = action.payload;
        },
        setRemoveUserDialogOpen: (state, action) => {
            state.isRemoveUserDialogOpen = !state.isRemoveUserDialogOpen;
            if (action.payload !== undefined) {
                state.selectedUserIdToDelete = action.payload;
            }
        },
        setRemoveUserFailedAlert: state => {
            state.isRemoveUserFailed = !state.isRemoveUserFailed;
        },
        setRemoveUserSuccessAlert: state => {
            state.isRemoveUserSuccess = !state.isRemoveUserSuccess;
        },
        setIsRemoveUserLoading: (state, action) => {
            state.isRemoveUserLoading = action.payload;
        },
    },
});
export const {
    setIsBulkImportOpen,
    setIsTemplateDownloadSuccess,
    setRemoveFileSuccessAlert,
    setRemoveFileFailedAlert,
    setIsTemplateDownloadFailed,
    setIsFetchFilesFailed,
    setIsFetchUsersFailed,
    setUploadDialogOpen,
    setShouldFileUpload,
    setUsers,
    setIsUploading,
    setCurrentFileName,
    setCurrentFileId,
    setOverallTotalItems,
    setIsImportSuccess,
    setIsImportError,
    clearImportError,
    setUpdatedRow,
    setIsUploadFileFailed,
    setIsUpdateUserFailed,
    deleteFileReducer,
    resetState,
    setRemoveCurrentFileDialogOpen,
    setIsRemoveFileLoading,
    setRemoveUserDialogOpen,
    setRemoveUserFailedAlert,
    setRemoveUserSuccessAlert,
    setIsRemoveUserLoading,
} = bulkImportUsersSlice.actions;
export default bulkImportUsersSlice.reducer;
